import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Hammer, House, MapPin, ChatCircle, ArrowRight, FileText } from '@phosphor-icons/react';

export const ContractorActiveProjects = ({ activeProjects, openChatWith }) => {
  const navigate = useNavigate();
  if (activeProjects.length === 0) return null;

  return (
    <div className="bg-white dark:bg-neutral-800 border-2 border-black dark:border-neutral-700 rounded-xl shadow-[4px_4px_0px_#000] dark:shadow-[4px_4px_0px_#2563EB] mb-6 overflow-hidden" data-testid="active-projects-section">
      <div className="p-5 bg-blue-50 dark:bg-blue-900/20 border-b-2 border-black dark:border-neutral-700 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#2563EB] rounded-lg flex items-center justify-center border-2 border-black">
            <Hammer size={22} weight="bold" className="text-white" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-neutral-900 dark:text-white">Active Projects</h2>
            <p className="text-sm text-neutral-600 dark:text-neutral-400">Homeowner projects you're working on</p>
          </div>
        </div>
        <span className="text-sm font-bold text-neutral-500">{activeProjects.length} project{activeProjects.length !== 1 ? 's' : ''}</span>
      </div>
      <div className="divide-y divide-neutral-200 dark:divide-neutral-700">
        {activeProjects.map((p) => (
          <div
            key={p.id}
            onClick={() => navigate(`/project/${p.id}`)}
            className="p-4 hover:bg-neutral-50 dark:hover:bg-neutral-700/50 cursor-pointer transition-colors flex items-center gap-4"
            data-testid={`project-card-${p.id}`}
          >
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <p className="font-bold text-neutral-900 dark:text-white text-sm truncate">{p.title}</p>
                <span className={`px-2 py-0.5 text-[10px] font-bold text-white ${
                  p.status === 'in_progress' ? 'bg-amber-500' : p.status === 'completed' ? 'bg-emerald-500' : 'bg-blue-500'
                }`}>{p.status === 'in_progress' ? 'Active' : p.status === 'completed' ? 'Done' : 'Planning'}</span>
              </div>
              <div className="flex items-center gap-3 text-xs text-neutral-500">
                <span className="flex items-center gap-1"><House size={12} weight="bold" /> {p.homeowner_name}</span>
                <span className="flex items-center gap-1"><MapPin size={12} weight="bold" /> {p.location}</span>
                {p.budget > 0 && <span className="text-emerald-600 font-bold">${Number(p.budget).toLocaleString()}</span>}
                {p.escrow_status === 'funded' && (
                  <span className="px-1.5 py-0.5 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 text-[10px] font-bold border border-emerald-300 dark:border-emerald-700 rounded">
                    ${Number(p.escrow_released || 0).toLocaleString()} / ${Number(p.escrow_total || 0).toLocaleString()}
                  </span>
                )}
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={(e) => { e.stopPropagation(); openChatWith(p.homeowner_id, p.homeowner_name); }}
                className="h-8 px-3 bg-[#2563EB] hover:bg-[#1D4ED8] text-[#0F172A] text-xs font-bold rounded-lg border border-[#203A55] flex items-center gap-1 transition-colors"
                data-testid={`message-project-${p.id}`}
              >
                <ChatCircle size={14} weight="bold" /> Chat
              </button>
              <button
                onClick={(e) => { e.stopPropagation(); navigate('/documents'); }}
                className="h-8 px-3 bg-white hover:bg-neutral-50 text-neutral-900 text-xs font-bold rounded-lg border border-black flex items-center gap-1 transition-colors"
                data-testid={`docs-project-${p.id}`}
                title="View contracts & change orders"
              >
                <FileText size={14} weight="bold" /> Docs
              </button>
              <div className="w-20">
                <div className="w-full h-2 bg-neutral-200 dark:bg-neutral-700 rounded-full overflow-hidden">
                  <div className="h-full bg-emerald-500 transition-all" style={{ width: `${p.progress}%` }} />
                </div>
                <p className="text-[10px] text-neutral-400 text-center mt-0.5">{p.progress}%</p>
              </div>
              <ArrowRight size={18} weight="bold" className="text-neutral-400" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
